import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GitQuery, GitService, GitStore } from '@y42/git';
import { WorkerActionParams } from '@y42/git/worker';
import { FeatureWasmGitService } from './feature-wasm-git.service';
import type { FSHydrateStoresAction } from './worker/actions/fs-hydrate-stores';
import type { FSReadGitStoreModelAction } from './worker/actions/fs-read-git-store-model';
import type { FSReadGitStoreModelsAction } from './worker/actions/fs-read-git-store-models';

@Injectable({ providedIn: 'root' })
export class FeatureGitClient extends GitService {
  constructor(protected readonly featureWasmGit: FeatureWasmGitService) {
    super(inject(GitStore), inject(GitQuery), featureWasmGit, inject(Router), inject(Location));
  }

  async hydrateStores(params: WorkerActionParams<FSHydrateStoresAction>) {
    return await this.featureWasmGit.hydrateStores(params);
  }

  async readGitStoreModels(params: WorkerActionParams<FSReadGitStoreModelsAction>) {
    return await this.featureWasmGit.readGitStoreModels(params);
  }

  async readGitStoreModel(params: WorkerActionParams<FSReadGitStoreModelAction>) {
    return await this.featureWasmGit.readGitStoreModel(params);
  }
}
